module.exports = __webpack_public_path__ + "img/微信图片_20240409165226.0d2df796.jpg";